import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import CompaniesActions, { CompaniesRedux, CompaniesTypes } from '../Redux/CompaniesRedux'

const companiesCRUDObservable = createCRUDObservable({
  mainRedux: CompaniesRedux,
  reduxPath: 'companies',
  dataHandlers: {
    get: response => response.data.data,
  },
})
const getCompaniesEpic = (action$, store, { Api }) => (
  action$.ofType(CompaniesTypes.getCenterCompanyRequest)
    .mergeMap(({ centerId }) => (
      Observable
        .fromPromise(Api.companies.getCenterCompanies(centerId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
                  CompaniesActions.getCenterCompanyError(response.error),
            ]
          }

          return [
                 CompaniesActions.getCenterCompanySuccess(response.data.data),
          ]
        })
    ))
)

export const companiesObservers = Object.assign({}, companiesCRUDObservable.observers, {})


export const companiesEpic = combineEpics(
  companiesCRUDObservable.epic, 
  getCompaniesEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CompaniesObservable.js